import { HttpErrorResponse } from '@angular/common/http';

import { AuthService } from './auth.service';
import { SessionEndReason } from './session-policy';

interface UnauthorizedPayload {
  reason?: string;
}

/** Resolves why the session ended; server reason wins over local idle/token checks. */
export function resolveSessionEndReason(
  auth: AuthService,
  err?: HttpErrorResponse | null,
): SessionEndReason {
  const serverReason = (err?.error as UnauthorizedPayload | undefined)?.reason;
  if (serverReason === 'logged_in_elsewhere') {
    return 'logged_in_elsewhere';
  }
  if (serverReason === 'session_expired') {
    return 'session_expired';
  }
  if (auth.isIdleExpiredLocally()) {
    return 'idle_expired';
  }
  return 'session_expired';
}
